import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MessengerService } from './messenger.service';
import { ProviderEdit } from 'src/app/provider/model/provider-edit';

@Injectable({
  providedIn: 'root'
})
export class ProviderService implements OnDestroy
{
  public providerDistances: Array<{ text: string; value: string }> = [
    { text: 'Mile', value: 'MILES' },
    { text: 'Km', value: 'KILOMETERS' },
  ];

  private messagingLanguageChangedSubscription: Subscription;

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private messengerService: MessengerService)
  {
    this.loadLocalizations();
    this.messagingLanguageChangedSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations();
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get the distance text to display.
   *
   * @param distance Distance value.
   */
  public getDistanceDisplayText(distance: string): string
  {
    let text = distance;
    const distanceObject = this.providerDistances.find(x => x.value === distance);
    if (distanceObject !== undefined)
    {
      text = distanceObject.text;
    }
    return text;
  }

  public addUpdateProviders(providers: any[], validateOnly: boolean, deleteProviders: boolean): Observable<any[]>
  {
    return this.http.post<any[]>(`/providers/batch?validateOnly=${validateOnly}&deleteProviders=${deleteProviders}`, providers);
  }

  /**
   * Get all Video providers from REST service.
   */
  public getVideoProviders(): Observable<any[]>
  {
    return this.http.get<any[]>('/video/providers');
  }

  public getProviderByNPI(npi: string): Observable<any[]>
  {
    return this.http.get<any[]>(`/providers?search=npi:eq:"${npi}":and'`);
  }

  /**
   * Check if Provider is in use
   *
   * @param id Provider id
   */
  public existsProvider(npi: string): Observable<any>
  {
    return this.http.get(`/provider/inuse/${npi}`);
  }

  /**
   * Get a Provider by id.
   *
   * @param id Provider id
   */
  public getProviderById(id: number): Observable<ProviderEdit>
  {
    return this.http.get<ProviderEdit>(`/provider/${id}`);
  }

  /**
   * Delete a Provider.
   *
   * @param id Provider id
   */
  public deleteProvider(id: number): Observable<ProviderEdit>
  {
    return this.http.delete<ProviderEdit>(`/provider/${id}`);
  }

  /**
   * Check if Provider Npi exists to avoid duplicates
   *
   * @param name Provider Npi
   */
  public existsProviderNpi(npi: string): Observable<any>
  {
    return this.http.get(`/provider/exists?npi=${npi}`);
  }

  /**
   * Save a Provider.
   *
   * @param data Provider to persit
   * @param isNew Indicate if this is a new or update
   */
  public saveProvider(data: any, isNew: boolean, id?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/provider', data);
    }
    else
    {
      return this.http.put(`/provider/${id}`, data);
    }
  }

  /**
   * Load localizations
   */
  private loadLocalizations(): void
  {
    setTimeout(() =>
    {
      this.translate.get(['DISTANCES']).subscribe({
        next: (res: any) =>
        {
          const splitted = res.DISTANCES.split(',');
          for (let i = 0; i < splitted.length; i++)
          {
            if (this.providerDistances.length > i)
            {
              this.providerDistances[i].text = splitted[i];
            }
          }
        }
      });
    });
  }
}
